var videoModal = /** @class */ (function () {
    function videoModal(url, obj) {
        var _a;
        this.parser = {
            youtube: {
                matcher: /(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(watch\?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*)).*/i,
                params: {
                    autoplay: 1,
                    autohide: 1,
                    fs: 1,
                    rel: 0,
                    hd: 1,
                    wmode: 'opaque',
                    enablejsapi: 1
                },
                type: 'iframe',
                url: '//www.youtube.com/embed/$3'
            },
            vimeo: {
                matcher: /(?:vimeo(?:pro)?.com)\/(?:[^\d]+)?(\d+)(?:.*)/,
                params: {
                    autoplay: 1,
                    hd: 1,
                    show_title: 1,
                    show_byline: 1,
                    show_portrait: 0,
                    fullscreen: 1
                },
                type: 'iframe',
                url: '//player.vimeo.com/video/$1'
            },
            metacafe: {
                matcher: /metacafe.com\/(?:watch|fplayer)\/([\w\-]{1,10})/,
                params: {
                    autoPlay: 'yes'
                },
                type: 'swf',
                url: function (rez, params, obj) {
                    obj.swf.flashVars = this.format('playerVars=', [], params);
                    return '//www.metacafe.com/fplayer/' + rez[1] + '/.swf';
                }
            },
            dailymotion: {
                matcher: /dailymotion.com\/video\/(.*)\/?(.*)/,
                params: {
                    additionalInfos: 0,
                    autoStart: 1
                },
                type: 'swf',
                url: '//www.dailymotion.com/swf/video/$1'
            },
            twitvid: {
                matcher: /twitvid\.com\/([a-zA-Z0-9_\-\?\=]+)/i,
                params: {
                    autoplay: 0
                },
                type: 'iframe',
                url: '//www.twitvid.com/embed.php?guid=$1'
            },
            twitpic: {
                matcher: /twitpic\.com\/(?!(?:place|photos|events)\/)([a-zA-Z0-9\?\=\-]+)/i,
                type: 'image',
                url: '//twitpic.com/show/full/$1/'
            },
            instagram: {
                matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
                type: 'image',
                url: '//$1/p/$2/media/?size=l'
            },
            google_maps: {
                matcher: /maps\.google\.([a-z]{2,3}(\.[a-z]{2})?)\/(\?ll=|maps\?)(.*)/i,
                type: 'iframe',
                url: function (rez) {
                    return '//maps.google.' + rez[1] + '/' + rez[3] + '' + rez[4] + '&output=' + (rez[4].indexOf('layer=c') > 0 ? 'svembed' : 'embed');
                }
            }
        };
        this.format = function (url, rez, params) {
            params = params || '';
            if (typeof params === "object") {
                var urlParams = new URLSearchParams(Object.entries(params));
                params = urlParams.toString();
            }
            for (var key in rez) {
                url = url.replace('$' + key, rez[key] || '');
            }
            if (params.length) {
                url += (url.indexOf('?') > 0 ? '&' : '?') + params;
            }
            return url;
        };
        if (url.length > 0) {
            var type = '', what, item, rez, params;
            for (what in this.parser) {
                item = this.parser[what];
                rez = url.match(item.matcher);
                if (rez) {
                    type = item.type;
                    params = Object.assign({}, (_a = item.params) !== null && _a !== void 0 ? _a : {});
                    if (typeof item.url === 'function') {
                        url = item.url.call(this, rez, params, obj);
                    }
                    else {
                        url = this.format(item.url, rez, params);
                    }
                    break;
                }
            }
            if (type == 'iframe' && obj instanceof HTMLIFrameElement) {
                obj.src = url;
            }
        }
    }
    return videoModal;
}());
export { videoModal };
